var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen w-full flex items-center justify-center"},[_c('div',{staticClass:"flex flex-col items-center"},[_c('div',[_vm._v(_vm._s(_vm.responseMessage))]),_c('div',{staticClass:"loading mt-2 mb-8 h-4"},[_c('ui-spinner',{staticClass:"mx-auto"})],1),_c('div',[_vm._v("Please wait...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }